import store from '@/store'
import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'
import { ApolloQueryResult } from '@apollo/client';


export type SearchCartItemCondition = {
  staffId?: number;
  selected?: boolean;
}

export function useSearchCartItemsFunc() {

  const getWhere = (condition: SearchCartItemCondition) => {
    // スタッフId --------------------
    let staffId = condition.staffId
    if (!staffId) {
      // ログイン中のスタッフIDで絞り込む
      staffId = store.getters['loginUser/staff']?.id
    }
    const where: api.CartItemWhereInput  = {
      AND: [
        {
          staff: {
            is: {
              id: { equals: staffId }
            }
          }
        }
      ],
    }
    
    // カート内で選択されているかどうかで絞り込む --------------------
    let selected = condition.selected
    if (selected !== undefined) {
      where.AND?.push({
        selected: {
          equals: selected
        }
      })
    }

    return where
  }

  /// トータル件数取得
  const {
    load: searchCartItemsCountLoad,
    refetch: searchCartItemsCountRefetch,
    onResult: searchCartItemsCountOnResult,
    onError: searchCartItemsCountOnError,
    loading: searchCartItemsCountLoading,
  } = useLazyQuery<
    api.CountCartItemsQuery,
    api.CountCartItemsQueryVariables
  >(api.CountCartItemsDocument, undefined)

  const searchCartItemsCountFetchOrRefetch = async (variables:api.CountCartItemsQueryVariables) => {
    return await searchCartItemsCountLoad(api.CountCartItemsDocument, variables, {
      fetchPolicy: 'network-only',
    }) || await searchCartItemsCountRefetch(variables)
  }

  const searchCartItemsCount = async ( condition: SearchCartItemCondition ) => {
    const where = getWhere(condition)
    // 検索実行
    const res = await searchCartItemsCountFetchOrRefetch({
      where,
    }) as ApolloQueryResult<api.CountCartItemsQuery>

    if (res.data?.aggregateCartItem) {
      return res.data.aggregateCartItem
    }
    return undefined
  }

  const {
    load: searchCartItemsLoad,
    refetch: searchCartItemsRefetch,
    onResult: searchCartItemsOnResult,
    onError: searchCartItemsOnError,
    loading: searchCartItemsLoading,
  } = useLazyQuery<
    api.CartItemsQuery,
    api.CartItemsQueryVariables
  >(api.CartItemsDocument, undefined)

  const searchCartItemsFetchOrRefetch = async (variables:api.CartItemsQueryVariables) => {
    return await searchCartItemsLoad(api.CartItemsDocument, variables, {
      fetchPolicy: 'network-only',
    }) || await searchCartItemsRefetch(variables)
  }

  const searchCartItems = async ( condition: SearchCartItemCondition ) => {
    const where = getWhere(condition)
    // 検索実行
    const res = await searchCartItemsFetchOrRefetch({
      where,
      orderBy: [
        {
          stockItem:{
            item: {
              largeCategory: {
                seq: {
                  sort: api.SortOrder.Asc
                }
              }
            }
          }
        },
        {
          stockItem:{
            item: {
              middleCategory: {
                seq: {
                  sort: api.SortOrder.Asc
                }
              }
            }
          }
        },
        {
          stockItem:{
            item: {
              smallCategory: {
                seq: {
                  sort: api.SortOrder.Asc
                }
              }
            }
          }
        },
        {
          stockItem:{
            item: {
              itemCd: {
                sort: api.SortOrder.Asc
              }
            }
          }
        },
        {
          stockItem: {
            diameterCd: api.SortOrder.Asc
          }
        },
        {
          stockItem: {
            lengthCd: api.SortOrder.Asc
          }
        }
      ]
    }) as ApolloQueryResult<api.CartItemsQuery>

    if (res.data?.cartItems) {
      return res.data.cartItems as api.CartItem[]
    } else {
      return [] as api.CartItem[]
    }
  }

  return {
    searchCartItemsCount,
    searchCartItemsCountOnResult,
    searchCartItemsCountOnError,
    searchCartItems,
    searchCartItemsOnResult,
    searchCartItemsOnError,
    searchCartItemsLoading,
  };
}
